export default __webpack_public_path__ + "static/media/kawaguchiko_lake_japan.4c148a30.webp";